import { Link, useNavigate, useParams } from "react-router-dom";
import { Footer } from "../../components/Footer";
import Header from "../../components/Header";
import patient from "../../assets/img/patient.jpg";
import { useEffect, useState } from "react";
import { CallWithAuth } from "../../action/apiActions";
import {
  GET_PATIENT_RELATIVES_API_URL,
  GET_PATIENT_RELATIVES_FILE_API_URL,
  GET_PATIENT_RELATIVES_SUBMIT_API_URL,
  SEND_MAIL_PATIENT_RELATIVES_API_URL,
} from "../../action/apiPath";
import { fileName, textRetriever, textRetrieverTextArea } from "../../util/custom";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { showToast, ToastContainer } from "../../util/toastHelper";

const MySwal = withReactContent(Swal);
const staticRelatives = [
  {
    id: 1,
    name: "Srikanth Y",
    email: "test1@yopmail.com",
    phone: "1236547890",
    isChecked: true,
  },
  {
    id: 2,
    name: "Srikanth G",
    email: "test2@yopmail.com",
    phone: "1236547890",
    isChecked: false,
  },
  {
    id: 3,
    name: "Srikanth M",
    email: "test3@yopmail.com",
    phone: "1236547890",
    isChecked: true,
  },
  {
    id: 4,
    name: "Srikanth M",
    email: "test4@yopmail.com",
    phone: "1236547890",
    isChecked: true,
  },
];
/**
 * The Patient Relatives Information Page component
 * @returns {JSX.Element} The component
 */
const PatientRelativesSubmitDetailInformationPage = () => {
  const navigate = useNavigate();

  const { id } = useParams();
  const [getRelativesData, setRelativesData] = useState([]);
  const [getRelativesDocs, setRelativesDocs] = useState([]);
  const [getRelativesDetail, setRelativesDetail] = useState([]);

  const [getRelativesDataDeatil, setRelativesDataDeatil] = useState([]);

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (id == undefined || id == "") {
      navigate("/");
      return;
    }
    getReleatives();
  }, [id]);

  /**
   * Fetch the relatives data from the API
   * @param {string} id The patient id
   * @returns {Promise<void>}
   */
  const getReleatives = async () => {
    try {
      /**
       * The API endpoint to fetch the relatives data
       * @type {string}
       */
      const url = `${GET_PATIENT_RELATIVES_FILE_API_URL}/${id}`;

      const response = await CallWithAuth("GET", url);

      if (response.res.data && response.res.data.statusCode === 200) {
        setRelativesDocs(response.res.data.data?.files ?? []);
        setRelativesDetail(response.res.data.data?.relative);
      }
      setIsLoading(false);
    } catch (error) {}
  };
  console.log("getRelativesDocs====>", getRelativesDocs);
  console.log("getRelativesDetail====>", getRelativesDetail);

  return (
    <>
      {isLoading && (
        // <><h1 className="text-center">Report loading...</h1></>
        <>
          <div className="full-page-loader">
            <div className="loader"></div>
          </div>
        </>
      )}
      <div>
        <section className="site_hero patient_management_banner">
          <div className="site_container">
            <div className="site_row">
              <div className="txt_colm">
                <div className="txt_block">
                  <h1>Patient Relative Details</h1>
                  {/* <p>E-Mail Send to Patient's Contacts</p> */}
                </div>
              </div>
              <div className="img_colm">
                <div className="img_block">
                  <img src={patient} alt="" />
                </div>
              </div>
            </div>
          </div>
        </section>

        {!isLoading && (
          <>
            <section className="site_container relative_table_new">
              {/* <div className="row w-100 mx-auto mt-5">
            <div className="col-lg-6 col-md-6 col-sm-6">
              <strong>Referral Information:</strong>{" "}
              {textRetriever(getRelativesDataDeatil?.referral_info)}
            </div>
            <div className="col-lg-6 col-md-6 col-sm-6">
              <strong>Presenting Concerns:</strong>{" "}
              {textRetriever(getRelativesDataDeatil?.present_concern)}
            </div>
          </div> */}
              <div className="row w-100 mx-auto mt-5">
                {getRelativesDetail.signature && (
                  <div className="col-lg-6 col-md-6 col-sm-6  mt-4">
                    <strong>Patient Signature:</strong>
                    <a
                      href={`${getRelativesDetail.signature}`} // Full URL for S3 file
                      target="_blank" // Opens link in a new tab
                      rel="noopener noreferrer" // Security best practice
                      className="edit"
                    >
                      <i className="fa-solid fa-eye"></i>
                    </a>
                  </div>
                )}
                <div className="col-lg-6 col-md-6 col-sm-6 mt-4">
                  <strong>Email:</strong>{" "}
                  {textRetriever(getRelativesDetail?.email)}
                </div>
                <div className="col-lg-6 col-md-6 col-sm-6 mt-4">
                  <strong>Name:</strong>{" "}
                  {textRetriever(getRelativesDetail?.name)}
                </div>
                <div className="col-lg-6 col-md-6 col-sm-6 mt-4">
                  <strong>Patient relevant extra info:</strong>{" "}
                  {/* {textRetriever(getRelativesDetail?.patient_relevant_extra_info)} */}
                  <p
                    dangerouslySetInnerHTML={{
                      __html: textRetrieverTextArea(getRelativesDetail?.patient_relevant_extra_info),
                    }}
                  />
                </div>
              </div>

              <div className="patient_form_block tables-container">
                <div className="d-flex justify-content-center gap-4">
                  {/* New Table */}
                  <div className="table-wrapper">
                    <h2>Documents</h2>
                    <div className="table-responsive">
                      <table className="table table-bordered new-table">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>File path</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {getRelativesDocs.length > 0 &&
                            getRelativesDocs?.map((doc, key) => (
                              <tr key={doc.id}>
                                <td>{key + 1}</td>
                                <td>{fileName(doc.file)}</td>
                                <td>
                                  <a
                                    href={`${doc.file}`} // Full URL for S3 file
                                    target="_blank" // Opens link in a new tab
                                    rel="noopener noreferrer" // Security best practice
                                    className="edit"
                                  >
                                    <i className="fa-solid fa-eye"></i>
                                  </a>
                                </td>
                              </tr>
                            ))}
                          {getRelativesDocs?.length == 0 && !isLoading && (
                            <>
                              <td colSpan={4} style={{ textAlign: "center" }}>
                                No data Found
                              </td>
                            </>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </>
        )}
      </div>
      <ToastContainer />
    </>
  );
};
export default PatientRelativesSubmitDetailInformationPage;
